import { Navigate, useParams } from "react-router";

/**
 * Where an old link to one session lands now: its agreements, the only thing
 * the session page ever showed.
 */
export default function SessionAgreementsRedirect() {
  const { id } = useParams<{ id: string }>();
  const target = id ? `/portal/agreements?session=${encodeURIComponent(id)}` : "/portal/agreements";
  return <Navigate to={target} replace />;
}
